<template>
    <div class="call-to-action no-print">
        <a href="#" class="solid-btn outline" @click="openModal(0)">Ask Us A Question</a>
        <a href="#" class="solid-btn outline" @click="openModal(1)">Report Campaign</a>
        <Modal
            :title="modalLabel[mode[current_mode]].title"
            v-model="showModal"
            class-name="vertical-center-modal">
            <div class="card-info">
                <form>
                    <div class="single-row">
                        <h6 class="title-6" :class="{'red-hover': payloadError.name}">Name*</h6>
                        <input class="input-field" :class="{'red-hover': payloadError.name}" value="" placeholder="Your name" type="text" v-model="modelData.name">
                        <br>
                        <!--<p class="text-danger" v-show="payloadError.name">This field is required</p>-->
                    </div>
                    <br>
                    <div class="single-row">
                        <h6 class="title-6" :class="{'red-hover': (payloadError.email || payloadError.emailFormat)}">Email*</h6>
                        <input class="input-field" :class="{'red-hover': (payloadError.email || payloadError.emailFormat)}" value="" placeholder="Your email" type="email" v-model="modelData.email">
                        <br>
                        <!--<p class="text-danger" v-show="payloadError.email">This field is required</p>-->
                        <!--<p class="text-danger" v-show="payloadError.emailFormat">Invalid email</p>-->
                    </div>
                    <br>
                    <div class="single-row">
                        <h6 class="title-6" :class="{'red-hover': payloadError.body}">{{modalLabel[mode[current_mode]].body}}*</h6><textarea v-model="modelData.body" :class="{'red-hover': payloadError.body}" class="input-field"
                                  placeholder=""
                                  rows="5" type="text" width="100%">
                        </textarea>
                        <br>
                        <!--<p class="text-danger" v-show="payloadError.body">This field is required</p>-->
                    </div>
                </form>
            </div>
            <div slot="footer">
                <div class="single-row text-right">
                    <button class="solid-btn outline cancel-btn"
                            @click="showModal=false"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Cancel
                    </button>
                    <button class="solid-btn"
                            @click.prevent="sendData"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        {{modalLabel[mode[current_mode]].btnSend}}
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {

        created(){
            this.routes.asking = window.App.globalData.routes.fundraiser_question;
            this.routes.reporting = window.App.globalData.routes.fundraiser_report;
        },
        props:{
            fundraiserId:{
                required:true,
                type:Number,
            }
        },
        data() {
            return {
                current_mode: 0,
                mode: ['asking', 'reporting'],
                modalLabel: {
                    asking: {
                        title: 'Ask us a question',
                        body: 'Your Question:',
                        btnSend: 'Ask'
                    },
                    reporting: {
                        title: 'Report Campaign',
                        body: 'Cause of Report:',
                        btnSend: 'Report'
                    }
                },
                showModal: false,

                modelData: {
                    name: '',
                    email: '',
                    body: ''
                },


                routes:{
                    asking:'',
                    reporting:''
                },

                validating:false,
            }
        },computed:{
            payloadError(){
                return {
                    name:this.validating && this.modelData.name.trim()==='',
                    email:this.validating && this.modelData.email.trim()==='',
                    emailFormat:(this.validating && this.modelData.email.trim()!=='') && !this.validEmail(this.modelData.email),
                    body:this.validating && this.modelData.body.trim()==='',
                }
            }
        },
        methods: {
            openModal(mode) {
                this.current_mode = mode;
                this.showModal = true;
                this.reset();
            },
            sendData(){
                if(this.validate()){
                    this.showModal = false;
                    let loading = this.$loading({fullscreen:true});
                    let uri = this.routes[this.mode[this.current_mode]];
                    uri = uri.replace('FID',this.fundraiserId);
                    axios.post(uri,this.modelData)
                        .then(response=>{
                            loading.close();
                            this.reset();
                            this.$notify({
                                title: 'Success',
                                message: response.data.response.message,
                                type: 'success'
                            });
                        }).catch(e=>console.log(e));
                }
            },
            validate(){
                this.validating = true;
                let hasErrors = false;
                for(let x in this.payloadError){
                    if(this.payloadError[x]){
                        hasErrors = true;
                    }
                }
                return !hasErrors;
            },
            validEmail(mail) {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                    return true;
                }
                return false
            },
            reset(){
                this.modelData = {
                    name: '',
                    email: '',
                    body: ''
                };
                this.validating = false;
            }
        }
    }
</script>

<style scoped lang="less">
    .vertical-center-modal {
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal {
            top: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/FundraiserReportQuestion.vue